import { fetchCalculation } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";

export async function updateCalculationPageState(
  isMasterKeyValid,
  languageKey,
  calculationFilters,
  setCalculationFilters,
  setCalculationData,
  profitMarginInputs,
  setProfitMarginInputs,
  translate
) {
  const isInitialLoad = calculationFilters.isInitialLoad;

  const requestBodyFilters = extractRequestBodyFromFilters(calculationFilters, isInitialLoad);

  const requestBodyMargins = (() => {
    const last = profitMarginInputs?.lastChanged;
    if (!last) {
      return {
        profitMarginPctOfGrossSalary: null,
        profitMarginPctOfSelfCosts: null,
      };
    }
    if (last === "pctOfGrossSalary") {
      return {
        profitMarginPctOfGrossSalary: profitMarginInputs?.pctOfGrossSalary ?? null,
        profitMarginPctOfSelfCosts: null,
      };
    }
    if (last === "pctOfSelfCosts") {
      return {
        profitMarginPctOfGrossSalary: null,
        profitMarginPctOfSelfCosts: profitMarginInputs?.pctOfSelfCosts ?? null,
      };
    }
    return {
      profitMarginPctOfGrossSalary: null,
      profitMarginPctOfSelfCosts: null,
    };
  })();

  const requestBody = { ...requestBodyFilters, ...requestBodyMargins };
  const calculationData = await fetchCalculation(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  const { context, reportData } = calculationData.data;

  const backendProfit = reportData?.values?.profitMargin;
  if (backendProfit) {
    setProfitMarginInputs(() => {
      return {
        pctOfSelfCosts: Number(backendProfit.pctOfSelfCosts).toFixed(1),
        pctOfGrossSalary: Number(backendProfit.pctOfGrossSalary).toFixed(1),
      };
    });
  }
  const submitedFilters = context.filters;
  const nextAvailableFilters = context.nextAvailableFilters;

  const updatedFilters = await updateFilters(calculationFilters, submitedFilters, nextAvailableFilters, isInitialLoad, isMasterKeyValid, translate);
  setCalculationFilters(updatedFilters);
  setCalculationData(reportData);
}
